'use client'

import { useEffect, useState } from 'react'

const CONSENT_KEY = 'ff_cookie_consent'

export default function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true)
    }
  }, [])

  function accept() {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    setVisible(false)
    window.dispatchEvent(new Event('cookieConsentAccepted'))
  }

  function decline() {
    localStorage.setItem(CONSENT_KEY, 'declined')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 border-t border-gray-700 px-6 py-4">
      <div className="max-w-5xl mx-auto flex flex-wrap items-center gap-4 justify-between">
        <p className="text-gray-300 text-sm leading-relaxed">
          We use cookies for anonymous analytics to improve FairFares.{' '}
          <a href="/privacy" className="underline text-gray-400 hover:text-white transition-colors">
            Privacy Policy
          </a>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={decline}
            className="text-sm text-gray-400 hover:text-white transition-colors px-4 py-3 min-h-[44px] inline-flex items-center"
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="text-sm bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg px-4 py-3 min-h-[44px] inline-flex items-center transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}
